"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDateValues = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./lib/format"), exports);
var date_fns_1 = require("date-fns");
/**
 * While we don't typically want to shallow wrap third party functionality,
 * the `set` function is poorly named, but commonly used in code.
 * This is one rare case where we want an alias.
 * Common usage: `setDateValues(date, { hour, minute, second });`
 */
Object.defineProperty(exports, "setDateValues", { enumerable: true, get: function () { return date_fns_1.set; } });
//# sourceMappingURL=index.js.map